
$('.menu-menu__title_wrp').on('click', function () {
    $(this).parent().toggleClass('active');
});

$('.header-menu-btn').on('click', function () {
    $('.menu-menu').fadeIn("fast");
});
$('.menu-menu__close').on('click', function () {
    $('.menu-menu').fadeOut("fast");
});


$('.header-search-btn').on('click', function () {
    $('.header_search_section').fadeIn("fast");
});
$('.header_search_section__close').on('click', function () {
    $('.header_search_section').fadeOut("fast");
});

document.addEventListener('DOMContentLoaded', () => {
    const width = window.innerWidth
    if (width < 768) {
        function changeText() {
            var maxlength = 84; //количество символов, которое должно отображаться
            var strGlobal = document.getElementsByClassName("post_2__preview");
            var strNum = strGlobal.length; //количество блоков с классом text
            for (var i = 0; i < strNum; i++) {
                strGlobal[i].innerHTML = strGlobal[i].innerHTML.slice(0, maxlength) + '...';
            }
        }
        changeText();
    }
});

function windowSize() {
    windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
    windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
}
windowSize();
$(window).resize(function () {
    windowSize();
    if (windowWidth < 768) {
        function changeText() {
            var maxlength = 84; //количество символов, которое должно отображаться
            var strGlobal = document.getElementsByClassName("post_2__preview");
            var strNum = strGlobal.length; //количество блоков с классом text
            for (var i = 0; i < strNum; i++) {
                strGlobal[i].innerHTML = strGlobal[i].innerHTML.slice(0, maxlength) + '...';
            }
        }
        changeText();
    }
});

/*$('.datepicker').calendar({
    l10n: {
        jan: "Січень",
        feb: "Лютий",
        mar: "Березень",
        apr: "Квітень",
        may: "Травень",
        jun: "Червень",
        jul: "Липень",
        aug: "Серпень",
        sep: "Вересень",
        oct: "Жовтень",
        nov: "Листопад",
        dec: "Грудень",
        mn: "Пн",
        tu: "Вт",
        we: "Ср",
        th: "Чт",
        fr: "Пт",
        sa: "Сб",
        su: "Нд"
    }
});*/

/*appendToCalendar();
$('.datepicker').on('jqyc.changeYear', function (event) {
    appendToCalendar();
});

function appendToCalendar() {
    $('.datepicker').calendar('appendText', '(3)', 2023, 3, 4);
}*/
var element = element || document;
var svgId = document.getElementById("CalendarYear");
var e;
var groupPrevious = svgId.querySelector('#previous');
var groupNext = svgId.querySelector('#next');
var yearLabel = document.getElementById("monthAndYear");
var holidaysArray = [];
var i = 0;
var xMonth = 0;
var targetDay;
var holidayPeriods = [];
var holidays = {
    holidayPeriods: {
        StartDay: [],
        StopDay: [],
        StartTime: [],
        StopTime: []
    }
};
var testAux;
var $calendar = document.getElementById("calendar");
var currentYear = new Date().getFullYear();
var calendarize = new Calendarize();
let elementValue = {};
let loader;
let r = 0;

function init(evt) {
    e = element.htmlElement || document;
    svgId = e.querySelector('#CalendarYear');
    groupPrevious.addEventListener("click", function () {
        PreviousYear();
    }, false);
    groupNext.addEventListener("click", function () {
        NextYear();
    }, false);
    yearLabel.textContent = new Date().getFullYear();
    calendarize.buildYearCalendar($calendar, currentYear);
    parseInputValues();
    $(".full-calendar").find(
        function(){
            $('.today').parent().addClass("current-month")
        }
    );
}

function getElementValues() {
    // GETTING DATA FROM THE VIEW DESIGNER ELEMENT
    elementValue = element.getValue();
    let errors = [undefined, 0, "0", null];
    let pass = !errors.includes(elementValue);
    let check = elementValue.watchDogSec != undefined // !Object.values(elementValue).includes(errors);
    return (pass && check);
    //return (elementValue != null);  // TODO ADD Pass & Check code
}

function Calendarize() {
    var monthNames = ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"];
    var dayNames = ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
    return {
        // Return the days in a month - given a year and the month number
        getDaysInMonth: function (month, year) {
            var date = new Date(year, month, 1);
            var days = [];
            while (date.getMonth() === month) {
                days.push(new Date(date));
                date.setDate(date.getDate() + 1);
            }
            return days;
        },
        // return an array of the first day of each month for a given year
        getMonthsInYear: function (year) {
            var date = new Date(year, 0, 1);
            var months = [];
            var monthCount = 0;
            while (monthCount < 12) {
                months.push(new Date(date));
                date.setMonth(date.getMonth() + 1);
                monthCount++;
            }
            return months;
        },
        getMonthsInRange: function (startDate, endDate) {
            var start = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
            var end = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
            var months = [];
            var monthCount = 0;
            while (start <= end) {
                months.push(new Date(start));
                start.setMonth(start.getMonth() + 1);
                monthCount++;
            }
            return months;
        },
        // Create a full 12-month calendar
        buildYearCalendar: function (el, year) {
            var _this = this;
            var months = _this.getMonthsInYear(year);
            var opts = {
                showMonth: true,
                showDaysOfWeek: true,
                showYear: true,
                clickHandler: function (e) {
                    targetDay = e.target;
                    ;
                    AddHolidayToCalendar(targetDay);
                }
            };
            months.forEach(function (a, b) {
                var $monthNode = _this.buildMonth(b, year, opts);
                el.appendChild($monthNode);
            });
        },
        buildMonthsInRange: function (el, opts, startDate, limit) {
            var _this = this;
            var endDate = new Date(new Date().setDate(startDate.getDate() + limit));
            var months = _this.getMonthsInRange(startDate, endDate);
            opts = opts || {};
            opts.limitDate = endDate || false;
            if (opts.reverse)
                months = months.reverse();
            months.forEach(function (a, b) {
                var month = a.getMonth();
                var year = a.getFullYear();
                var $monthNode = _this.buildMonth(month, year, opts);
                el.appendChild($monthNode);
            });
        },
        // Add days and place fillers for a given month
        // This function and the one above needs consolidated
        buildMonth: function (monthNum, year, opts) {
            //if (monthNum === undefined || year === undefined) return "something is missing";
            var _this = this;
            var dtm = new Date(year, monthNum, 1);
            var dtmMonth = dtm.getMonth();
            var prevM = new Date(dtm.setMonth(dtmMonth - 1));
            var nextM = new Date(dtm.setMonth(dtmMonth + 1));
            var daysInMonth = _this.getDaysInMonth(monthNum, year);
            var daysPrevMonth = _this.getDaysInMonth(prevM.getMonth(), prevM.getFullYear());
            var daysNextMonth = _this.getDaysInMonth(nextM.getMonth(), nextM.getFullYear());
            var $monthNode = document.createElement('div');
            var $titleNode = document.createElement('h4');
            var skipLength = daysInMonth[0].getDay();
            var preLength = daysInMonth.length + skipLength;
            var postLength = function () {
                if (preLength % 7 === 0) {
                    return 0;
                } else {
                    if (preLength < 35) {
                        return 35 - preLength;
                    } else {
                        return 42 - preLength;
                    }
                }
            }
            $monthNode.classList.add('month', 'col-sm-6', 'col-md-4', 'col-lg-3', 'col-xl-3');
            // Add a Title to the month
            if (opts.showMonth) {
                $titleNode.innerText = monthNames[monthNum] + (opts.showYear ? " " + year : '');
                $monthNode.appendChild($titleNode);
            }
            // Add Days of week to the top row
            if (opts.showDaysOfWeek) {
                dayNames.forEach(function (a, b) {
                    var $dayNode = document.createElement('div');
                    $dayNode.classList.add('dow');
                    $dayNode.innerText = dayNames[b];
                    $monthNode.appendChild($dayNode);
                });
            }
            // Add blank days to fill in before first day
            for (var i = 0; i < skipLength; i++) {
                var $dayNode = document.createElement('div');
                $dayNode.classList.add('dummy-day');
                $dayNode.innerText = daysPrevMonth.length - (skipLength - (i + 1));
                $monthNode.appendChild($dayNode);
            }
            // Place a day for each day of the month
            daysInMonth.forEach(function (c, d) {
                var monthAux = monthNum + 1;
                var today = new Date(new Date().setHours(0, 0, 0, 0));
                var $dayNode = document.createElement('div');
                $dayNode.classList.add('day');
                $dayNode.setAttribute("data-date", c);
                $dayNode.setAttribute("id", monthAux + "." + (d + 1));
                $dayNode.innerText = (d + 1);
                var dow = new Date(c).getDay();
                var dateParsed = Date.parse(c);
                var todayParsed = Date.parse(today);
                if (dateParsed === todayParsed) $dayNode.classList.add('today');
                if (dateParsed > todayParsed) $dayNode.classList.add('future');
                if (dateParsed <todayParsed) $dayNode.classList.add('past');
                if (dow === 0) $dayNode.classList.add('weekend');
                if (opts.onlyCurrent && c < today) $dayNode.classList.add('dummy-day');
                if (opts.limitDate) {
                    if (c > opts.limitDate) {
                        $dayNode.classList.add('dummy-day');
                    }
                }
                if (opts.filterDayOfWeek) {
                    var valid = false;
                    for (var i = 0; i < opts.filterDayOfWeek.length; i++) {
                        if (c.getDay() == opts.filterDayOfWeek[i]) {
                            valid = true;
                        }
                    }
                    if (!valid) {
                        $dayNode.classList.add('dummy-day');
                    }
                }
                if (opts.clickHandler && !$dayNode.classList.contains('dummy-day')) {
                    function handleEvent(e) {
                        e = e || window.event;
                        e.preventDefault();
                        e.stopPropagation();
                        var touches = false;
                        if (!touches) {
                            touches = true;
                            setTimeout(function () {
                                touches = false;
                            }, 300);
                            opts.clickHandler(e);
                        }
                    }

                    $dayNode.addEventListener("click", handleEvent);
                }
                $monthNode.appendChild($dayNode);
            });
            // Add in the dummy filler days to make an even block
            for (var j = 0; j < postLength(); j++) {
                var $dayNode = document.createElement('div');
                $dayNode.classList.add('dummy-day');
                $dayNode.innerText = j + 1;
                $monthNode.appendChild($dayNode);
            }
            return $monthNode;
        }
    }
}

function NextYear() {
    var auxYear = yearLabel.textContent;
    auxYear = parseInt(auxYear) + 1;
    yearLabel.textContent = auxYear;
    var calendarAux = document.getElementById("calendar");
    calendarAux.innerHTML = "";
    calendarize.buildYearCalendar($calendar, auxYear);
    i = 0;
    AddHoliday(testAux);
}

function PreviousYear() {
    var auxYear = yearLabel.textContent;
    auxYear = parseInt(auxYear) - 1;
    yearLabel.textContent = auxYear;
    var calendarAux = document.getElementById("calendar");
    calendarAux.innerHTML = "";
    calendarize.buildYearCalendar($calendar, auxYear);
    i = 0;
    AddHoliday(testAux);
}

function AddHoliday(testAux) {
    var auxSelectedDays = [];
    var auxDayInBetween = 0;
    var auxStartArray = [];
    var auxStartArraySplited = [];
    var auxStopArray = [];
    var auxStopTime = [];
    var auxStopArraySplited = [];
    var numberOfDays = 0;
    var finalArray = [];
    auxStartArray = holidayPeriods.StartDay;
    auxStopArray = holidayPeriods.StopDay;
    auxStopTime = holidayPeriods.StopTime;
    for (var z = 0; z < auxStartArray.length; z++) {
        if (auxStopTime[z] == 24) {
            var valueStart = parseFloat(auxStartArray[z]).toFixed(2);
            var valueStop = parseFloat(auxStopArray[z]).toFixed(2);
            var auxValueStart = valueStart.split(".");
            var auxValueStop = valueStop.split(".");
            var auxDaysInARow = 0;
            var daysInMonthPeriod = 0;
            if (auxValueStart[0] == 1 || auxValueStart[0] == 3 || auxValueStart[0] == 5 || auxValueStart[0] == 7 || auxValueStart[0] == 8 || auxValueStart[0] == 10 || auxValueStart[0] == 12)
                daysInMonthPeriod = 31;
            else if (auxValueStart[0] == 2)
                daysInMonthPeriod = 28;
            else
                daysInMonthPeriod = 30;
            if (parseFloat(valueStart) == parseFloat(valueStop)) {
                auxSelectedDays[numberOfDays] = parseFloat(valueStart).toFixed(2);
                numberOfDays++;
            } else {
                if (parseInt(auxValueStart[0]) == parseInt(auxValueStop[0])) {
                    if (parseFloat(valueStart) == (parseFloat(valueStop) - parseFloat(0.01))) {
                        auxSelectedDays[numberOfDays] = parseFloat(valueStart).toFixed(2);
                        numberOfDays++;
                        auxSelectedDays[numberOfDays] = parseFloat(valueStop).toFixed(2);
                        numberOfDays++;
                    } else {
                        auxDaysInARow = ((parseFloat(valueStop).toFixed(2) - parseFloat(valueStart).toFixed(2)) * 100).toFixed(0);
                        auxSelectedDays[numberOfDays] = parseFloat(valueStart).toFixed(2);
                        numberOfDays++;
                        for (var n = 1; n < auxDaysInARow; n++) {
                            var auxDayInBetween = parseFloat(valueStart) + (parseFloat(n / 100));
                            auxDayInBetween = parseFloat(auxDayInBetween).toFixed(2);
                            auxSelectedDays[numberOfDays] = auxDayInBetween.toString();
                            numberOfDays++;
                        }
                        auxSelectedDays[numberOfDays] = parseFloat(valueStop).toFixed(2);
                        numberOfDays++;
                    }
                } else {
                    var auxFinalDayMonthStop = (parseFloat(auxValueStart[0]) + parseFloat(daysInMonthPeriod / 100)).toFixed(2);
                    auxDaysInARow = ((parseFloat(auxFinalDayMonthStop).toFixed(2) - parseFloat(valueStart).toFixed(2)) * 100).toFixed(0);
                    auxSelectedDays[numberOfDays] = parseFloat(valueStart).toFixed(2);
                    numberOfDays++;
                    for (var n = 1; n < (parseInt(auxDaysInARow) + parseInt(1)); n++) {
                        var auxDayInBetween = parseFloat(valueStart) + (parseFloat(n / 100));
                        auxDayInBetween = parseFloat(auxDayInBetween).toFixed(2);
                        auxSelectedDays[numberOfDays] = auxDayInBetween.toString();
                        numberOfDays++;
                    }
                    var auxFinalDayMonthBeggining = (parseFloat(auxValueStop[0]) + parseFloat(0.01)).toFixed(2);
                    auxDaysInARow = ((parseFloat(valueStop).toFixed(2) - parseFloat(auxFinalDayMonthBeggining).toFixed(2)) * 100).toFixed(0);
                    auxSelectedDays[numberOfDays] = parseFloat(valueStop).toFixed(2);
                    numberOfDays++;
                    for (var t = 1; t < (parseInt(auxDaysInARow) + parseInt(1)); t++) {
                        var auxDayInBetween = parseFloat(valueStop) - (parseFloat(t / 100));
                        auxDayInBetween = parseFloat(auxDayInBetween).toFixed(2);
                        auxSelectedDays[numberOfDays] = auxDayInBetween.toString();
                        numberOfDays++;
                    }
                }
            }
        }
    }
    for (var z = 0; z < auxSelectedDays.length; z++) {
        auxStartArraySplited[z] = auxSelectedDays[z].split(".");
    }
    for (var z = 0; z < auxStartArraySplited.length; z++) {
        var auxFinalString;
        auxStartArraySplited[z][1] = parseInt(auxStartArraySplited[z][1], 10);
        auxFinalString = auxStartArraySplited[z][0] + "." + auxStartArraySplited[z][1];
        finalArray[z] = auxFinalString;
        AddHolidayToCalendar(document.getElementById(finalArray[z]))
    }
}

function AddHolidayToCalendar(targetDay) {
    var day = targetDay.getAttribute("data-date");
    var auxDayParse = day.split(" ");
    var daysInMonth;
    switch (auxDayParse[1]) {
        case "Jan":
            auxDayParse[1] = 1;
            daysInMonth = 31;
            break;
        case "Feb":
            auxDayParse[1] = 2;
            daysInMonth = 28;
            break;
        case "Mar":
            auxDayParse[1] = 3;
            daysInMonth = 31;
            break;
        case "Apr":
            auxDayParse[1] = 4;
            daysInMonth = 30;
            break;
        case "May":
            auxDayParse[1] = 5;
            daysInMonth = 31;
            break;
        case "Jun":
            auxDayParse[1] = 6;
            daysInMonth = 30;
            break;
        case "Jul":
            auxDayParse[1] = 7;
            daysInMonth = 31;
            break;
        case "Aug":
            auxDayParse[1] = 8;
            daysInMonth = 31;
            break;
        case "Sep":
            auxDayParse[1] = 9;
            daysInMonth = 30;
            break;
        case "Oct":
            auxDayParse[1] = 10;
            daysInMonth = 31;
            break;
        case "Nov":
            auxDayParse[1] = 11;
            daysInMonth = 30;
            break;
        case "Dec":
            auxDayParse[1] = 12;
            daysInMonth = 31;
            break;
        default:
    }
    var finalDayString = auxDayParse[1] + "." + auxDayParse[2];
    var test = targetDay.classList.value;
    if (!test.includes("selectedDay")) {
        targetDay.classList.add('selectedDay');
        if (holidaysArray.length == 0) {
            holidaysArray[i] = {
                startDay: finalDayString,
                stopDay: finalDayString,
                startTime: 0,
                stopTime: 24
            };
        } else if (holidaysArray.length != 0) {
            var NextOrPrevious = 0;
            var indexObject = 0;
            var parseStartDay;
            var parseStopDay;
            var auxDayString;
            var checkComesFirst = 0; //0 -> Alone   1 - previousDay  2- Next day
            var hasSeveralDays = 0;
            var auxArray = [];
            var daysInMonthAux = 0;
            var monthAuxForAdding = 0;
            for (var x = 0; x < holidaysArray.length; x++) {
                // this month -> auxDayParse[1]          this day -> auxDayParse[2]
                parseStartDay = holidaysArray[x].startDay.split(".");
                parseStopDay = holidaysArray[x].stopDay.split(".");
                if (parseStartDay[0] == 1 || parseStartDay[0] == 3 || parseStartDay[0] == 5 || parseStartDay[0] == 7 || parseStartDay[0] == 8 || parseStartDay[0] == 10 || parseStartDay[0] == 12)
                    daysInMonthAux = 31;
                else if (parseStartDay[0] == 2)
                    daysInMonthAux = 28;
                else
                    daysInMonthAux = 30;
                if (parseInt(parseStartDay[0]) == parseInt(auxDayParse[1]) || parseInt(parseStopDay[0]) == parseInt(auxDayParse[1])) //Same month
                {
                    if (parseInt(parseStartDay[1]) == (parseInt(auxDayParse[2]) - parseInt(1)) && parseInt(parseStartDay[0]) == parseInt(auxDayParse[1])) //Next day with a single day
                    {
                        auxArray[hasSeveralDays] = holidaysArray[x].startDay;
                        auxArray[hasSeveralDays + 1] = holidaysArray[x].stopDay;
                        auxArray[hasSeveralDays + 2] = x;
                        if (hasSeveralDays > 3) {
                            auxArray[hasSeveralDays + 3] = 1;
                        } else {
                            auxArray[hasSeveralDays + 3] = 0;
                        }
                        indexObject = x;
                        NextOrPrevious = 1;
                        auxDayString = parseStartDay[0] + "." + parseStartDay[1];
                        hasSeveralDays = hasSeveralDays + 4;
                        monthAuxForAdding = 0;
                    } else {
                        if (parseInt(parseStartDay[1]) == (parseInt(auxDayParse[2]) + parseInt(1)) && parseInt(parseStartDay[0]) == parseInt(auxDayParse[1])) //Previous Day with a single day
                        {
                            auxArray[hasSeveralDays] = holidaysArray[x].startDay;
                            auxArray[hasSeveralDays + 1] = holidaysArray[x].stopDay;
                            auxArray[hasSeveralDays + 2] = x;
                            if (hasSeveralDays > 3) {
                                auxArray[hasSeveralDays + 3] = 0;
                            } else {
                                auxArray[hasSeveralDays + 3] = 1;
                            }
                            indexObject = x;
                            NextOrPrevious = 2;
                            auxDayString = parseStopDay[0] + "." + parseStopDay[1];
                            hasSeveralDays = hasSeveralDays + 4;
                            monthAuxForAdding = 0;
                        } else {
                            if (parseInt(parseStopDay[1]) == (parseInt(auxDayParse[2]) - parseInt(1)) && parseInt(parseStopDay[0]) == parseInt(auxDayParse[1])) //Next Day with several days
                            {
                                auxArray[hasSeveralDays] = holidaysArray[x].startDay;
                                auxArray[hasSeveralDays + 1] = holidaysArray[x].stopDay;
                                auxArray[hasSeveralDays + 2] = x;
                                if (hasSeveralDays > 3) {
                                    auxArray[hasSeveralDays + 3] = 1;
                                } else {
                                    auxArray[hasSeveralDays + 3] = 0;
                                }
                                indexObject = x;
                                NextOrPrevious = 3;
                                auxDayString = parseStartDay[0] + "." + parseStartDay[1];
                                hasSeveralDays = hasSeveralDays + 4;
                                monthAuxForAdding = 0;
                            } else {
                                if (parseInt(parseStopDay[1]) == (parseInt(auxDayParse[2]) + parseInt(1)) && parseInt(parseStopDay[0]) == parseInt(auxDayParse[1])) //Previous Day with several days
                                {
                                    auxArray[hasSeveralDays] = holidaysArray[x].startDay;
                                    auxArray[hasSeveralDays + 1] = holidaysArray[x].stopDay;
                                    auxArray[hasSeveralDays + 2] = x;
                                    if (hasSeveralDays > 3) {
                                        auxArray[hasSeveralDays + 3] = 0;
                                    } else {
                                        auxArray[hasSeveralDays + 3] = 1;
                                    }
                                    indexObject = x;
                                    NextOrPrevious = 4;
                                    auxDayString = parseStopDay[0] + "." + parseStopDay[1];
                                    hasSeveralDays = hasSeveralDays + 4;
                                    monthAuxForAdding = 0;
                                }
                            }
                        }
                    }
                } else { //different month
                    if (((parseInt(parseStartDay[0]) - parseInt(1)) == parseInt(auxDayParse[1])) && (parseInt(auxDayParse[2]) == daysInMonth && (parseInt(parseStartDay[1]) == 1))) { //Day selected is from the next month
                        auxArray[hasSeveralDays] = holidaysArray[x].startDay;
                        auxArray[hasSeveralDays + 1] = holidaysArray[x].stopDay;
                        auxArray[hasSeveralDays + 2] = x;
                        if (hasSeveralDays > 3) {
                            auxArray[hasSeveralDays + 3] = 0;
                        } else {
                            auxArray[hasSeveralDays + 3] = 1;
                        }
                        indexObject = x;
                        NextOrPrevious = 2;
                        auxDayString = parseStopDay[0] + "." + parseStopDay[1];
                        hasSeveralDays = hasSeveralDays + 4;
                        monthAuxForAdding = 1;
                    } else {
                        if (((parseInt(parseStartDay[0]) + parseInt(1)) == parseInt(auxDayParse[1])) && (parseInt(auxDayParse[2]) == 1 && (parseInt(parseStartDay[1]) == daysInMonthAux))) { //Day selected is from the previous month
                            auxArray[hasSeveralDays] = holidaysArray[x].startDay;
                            auxArray[hasSeveralDays + 1] = holidaysArray[x].stopDay;
                            auxArray[hasSeveralDays + 2] = x;
                            if (hasSeveralDays > 3) {
                                auxArray[hasSeveralDays + 3] = 1;
                            } else {
                                auxArray[hasSeveralDays + 3] = 0;
                            }
                            indexObject = x;
                            NextOrPrevious = 1;
                            auxDayString = parseStartDay[0] + "." + parseStartDay[1];
                            hasSeveralDays = hasSeveralDays + 4;
                            monthAuxForAdding = 2;
                        } else {
                            if (((parseInt(parseStopDay[0]) - parseInt(1)) == parseInt(auxDayParse[1])) && (parseInt(auxDayParse[2]) == daysInMonth && (parseInt(parseStopDay[1]) == 1))) { //Day selected is from the next month several
                                auxArray[hasSeveralDays] = holidaysArray[x].startDay;
                                auxArray[hasSeveralDays + 1] = holidaysArray[x].stopDay;
                                auxArray[hasSeveralDays + 2] = x;
                                if (hasSeveralDays > 3) {
                                    auxArray[hasSeveralDays + 3] = 0;
                                } else {
                                    auxArray[hasSeveralDays + 3] = 1;
                                }
                                indexObject = x;
                                NextOrPrevious = 4;
                                auxDayString = parseStopDay[0] + "." + parseStopDay[1];
                                hasSeveralDays = hasSeveralDays + 4;
                                monthAuxForAdding = 3;
                            } else {
                                if (((parseInt(parseStopDay[0]) + parseInt(1)) == parseInt(auxDayParse[1])) && (parseInt(auxDayParse[2]) == 1 && (parseInt(parseStopDay[1]) == daysInMonthAux))) { //Day selected is from the previous month several
                                    auxArray[hasSeveralDays] = holidaysArray[x].startDay;
                                    auxArray[hasSeveralDays + 1] = holidaysArray[x].stopDay;
                                    auxArray[hasSeveralDays + 2] = x;
                                    if (hasSeveralDays > 3) {
                                        auxArray[hasSeveralDays + 3] = 1;
                                    } else {
                                        auxArray[hasSeveralDays + 3] = 0;
                                    }
                                    indexObject = x;
                                    NextOrPrevious = 3;
                                    auxDayString = parseStartDay[0] + "." + parseStartDay[1];
                                    hasSeveralDays = hasSeveralDays + 4;
                                    monthAuxForAdding = 4;
                                }
                            }
                        }
                    }
                }
            }
        }
        if (hasSeveralDays > 4) {
            if (auxArray[2] > auxArray[6]) {
                holidaysArray.splice(auxArray[2], 1);
                if (auxArray[3] == 0)
                    holidaysArray[auxArray[6]] = {
                        startDay: auxArray[0],
                        stopDay: auxArray[5],
                        startTime: 0,
                        stopTime: 24
                    };
                else
                    holidaysArray[auxArray[6]] = {
                        startDay: auxArray[4],
                        stopDay: auxArray[1],
                        startTime: 0,
                        stopTime: 24
                    };
            } else {
                holidaysArray.splice(auxArray[6], 1);
                if (auxArray[3] == 0)
                    holidaysArray[auxArray[2]] = {
                        startDay: auxArray[0],
                        stopDay: auxArray[5],
                        startTime: 0,
                        stopTime: 24
                    };
                else
                    holidaysArray[auxArray[2]] = {
                        startDay: auxArray[4],
                        stopDay: auxArray[1],
                        startTime: 0,
                        stopTime: 24
                    };
            }
            i = i - 1;
        } else {
            switch (NextOrPrevious) {
                case 0:
                    holidaysArray[i] = {
                        startDay: finalDayString,
                        stopDay: finalDayString,
                        startTime: 0,
                        stopTime: 24
                    };
                    i = i + 1;
                    break;
                case 1:
                    holidaysArray[indexObject] = {
                        startDay: auxDayString,
                        stopDay: finalDayString,
                        startTime: 0,
                        stopTime: 24
                    };
                    break;
                case 2:
                    holidaysArray[indexObject] = {
                        startDay: finalDayString,
                        stopDay: auxDayString,
                        startTime: 0,
                        stopTime: 24
                    };
                    break;
                case 3:
                    holidaysArray[indexObject] = {
                        startDay: auxDayString,
                        stopDay: finalDayString,
                        startTime: 0,
                        stopTime: 24
                    };
                    break;
                case 4:
                    holidaysArray[indexObject] = {
                        startDay: finalDayString,
                        stopDay: auxDayString,
                        startTime: 0,
                        stopTime: 24
                    };
                    break;
                default:
                    holidaysArray[i] = {
                        startDay: finalDayString,
                        stopDay: finalDayString,
                        startTime: 0,
                        stopTime: 24
                    };
                    i = i + 1;
            }
        }
    } else if (test.includes("selectedDay")) {
        targetDay.classList.remove("selectedDay");
        for (var x = 0; x < parseInt(holidaysArray.length); x++) {
            if (holidaysArray[x].startDay == finalDayString && holidaysArray[x].stopDay == finalDayString) {
                holidaysArray.splice(x, 1);
                i = i - 1;
            } else {
                var numberDaysInMonthStart = 0;
                var numberDaysInMonthStop = 0;
                var auxStartDayForMonthCheck = holidaysArray[x].startDay;
                var auxMonthStartSplit = auxStartDayForMonthCheck.split(".");
                var auxStopDayForMonthCheck = holidaysArray[x].stopDay;
                var auxMonthStopSplit = auxStopDayForMonthCheck.split(".");
                if (auxStartDayForMonthCheck[0] == 1 || auxStartDayForMonthCheck[0] == 3 || auxStartDayForMonthCheck[0] == 5 || auxStartDayForMonthCheck[0] == 7 || auxStartDayForMonthCheck[0] == 8 || auxStartDayForMonthCheck[0] == 10 || auxStartDayForMonthCheck[0] == 12)
                    numberDaysInMonthStart = 31;
                else if (auxStartDayForMonthCheck[0] == 2)
                    numberDaysInMonthStart = 28;
                else
                    numberDaysInMonthStart = 30;
                if (auxStopDayForMonthCheck[0] == 1 || auxStopDayForMonthCheck[0] == 3 || auxStopDayForMonthCheck[0] == 5 || auxStopDayForMonthCheck[0] == 7 || auxStopDayForMonthCheck[0] == 8 || auxStopDayForMonthCheck[0] == 10 || auxStopDayForMonthCheck[0] == 12)
                    numberDaysInMonthStop = 31;
                else if (auxStopDayForMonthCheck[0] == 2)
                    numberDaysInMonthStop = 28;
                else
                    numberDaysInMonthStop = 30;
                if ((parseInt(auxDayParse[2]) == parseInt(daysInMonth) || parseInt(auxDayParse[2]) == 1) && (parseInt(auxMonthStopSplit[0]) != parseInt(auxMonthStartSplit[0])) && (parseFloat(finalDayString) >= parseFloat(auxStartDayForMonthCheck) && parseFloat(finalDayString) <= parseFloat(auxStopDayForMonthCheck))) {
                    if ((parseInt(auxDayParse[2]) == parseInt(auxMonthStopSplit[1])) && (parseInt(auxDayParse[2]) == 1)) {
                        finalDayString = auxMonthStartSplit[0] + "." + numberDaysInMonthStart;
                        holidaysArray[x].stopDay = finalDayString;
                    } else {
                        if ((parseInt(auxDayParse[2]) == parseInt(auxMonthStartSplit[1])) && (parseInt(auxDayParse[2]) == daysInMonth)) {
                            finalDayString = auxMonthStopSplit[0] + "." + "01";
                            holidaysArray[x].startDay = finalDayString;
                        } else {
                            if ((parseInt(auxDayParse[2]) > parseInt(auxMonthStartSplit[1])) && (parseInt(auxDayParse[2]) == daysInMonth)) {
                                var auxDay = parseInt(auxDayParse[2]) - 1;
                                auxDay = auxDay.toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false
                                })
                                var finalDayString2 = auxDayParse[1] + "." + auxDay;
                                var posIndex = parseInt(holidaysArray.length);
                                holidaysArray[posIndex] = {
                                    startDay: holidaysArray[x].startDay,
                                    stopDay: finalDayString2,
                                    startTime: 0,
                                    stopTime: 24
                                };
                                var finalDayStringAux1 = auxMonthStopSplit[0] + "." + "01";
                                holidaysArray[x].startDay = finalDayStringAux1;
                                i = i + 1;
                            } else {
                                if ((parseInt(auxDayParse[2]) < parseInt(auxMonthStopSplit[1])) && (parseInt(auxDayParse[2]) == 1)) {
                                    var auxDay = parseInt(auxDayParse[2]) + 1;
                                    auxDay = auxDay.toLocaleString('en-US', {
                                        minimumIntegerDigits: 2,
                                        useGrouping: false
                                    })
                                    var finalDayString2 = auxDayParse[1] + "." + auxDay;
                                    var posIndex = parseInt(holidaysArray.length);
                                    holidaysArray[posIndex] = {
                                        startDay: finalDayString2,
                                        stopDay: holidaysArray[x].stopDay,
                                        startTime: 0,
                                        stopTime: 24
                                    };
                                    var finalDayStringAux1 = auxMonthStartSplit[0] + "." + numberDaysInMonthStart;
                                    holidaysArray[x].stopDay = finalDayStringAux1;
                                    i = i + 1;
                                }
                            }
                        }
                    }
                } else {
                    if (holidaysArray[x].startDay == finalDayString) {
                        auxDayParse[2] = parseInt(auxDayParse[2]) + parseInt(1);
                        auxDayParse[2] = (auxDayParse[2]).toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                        finalDayString = auxDayParse[1] + "." + auxDayParse[2];
                        holidaysArray[x].startDay = finalDayString;
                        i = i - 1;
                    } else {
                        if (holidaysArray[x].stopDay == finalDayString) {
                            auxDayParse[2] = parseInt(auxDayParse[2]) - parseInt(1);
                            auxDayParse[2] = (auxDayParse[2]).toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            });
                            finalDayString = auxDayParse[1] + "." + auxDayParse[2];
                            holidaysArray[x].stopDay = finalDayString;
                            i = i - 1;
                        } else {
                            if ((holidaysArray[x].startDay < finalDayString) && (holidaysArray[x].stopDay > finalDayString)) {
                                var auxDayParse2 = parseInt(auxDayParse[2]) + parseInt(1);
                                auxDayParse2 = (auxDayParse2).toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false
                                })
                                var finalDayStringAux2 = auxDayParse[1] + "." + auxDayParse2;
                                var posIndex = parseInt(holidaysArray.length);
                                holidaysArray[posIndex] = {
                                    startDay: finalDayStringAux2,
                                    stopDay: holidaysArray[x].stopDay,
                                    startTime: 0,
                                    stopTime: 24
                                };
                                var auxDayParse1 = parseInt(auxDayParse[2]) - parseInt(1);
                                auxDayParse1 = (auxDayParse1).toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false
                                })
                                var finalDayStringAux1 = auxDayParse[1] + "." + auxDayParse1;
                                holidaysArray[x].stopDay = finalDayStringAux1;
                                i = i + 1;
                            }
                        }
                    }
                }
            }
        }
    }
    if (i < 0)
        i = 0;
    SaveInArray();
}

function parseInputValues() {
    let holidayInput = elementValue.holidays;
    for (var prop in holidayInput) {
        //if (!timeChannelInput.hasOwnProperty(prop)) continue;
        //let channel = timeChannelInput[prop];
        //channel.Start = channel.Start.map(element => EXOtoTime(element));
        //channel.Stop = channel.Stop.map(element => EXOtoTime(element));
        holidayPeriods = holidayInput.holidayPeriods;
        AddHoliday(holidayPeriods);
    }
    //	holidayPeriods = elementsValue.holidays.holidayPeriods;
    //	AddHoliday(holidayPeriods);
}

function SaveInArray() {
    while (holidays.length > 0) {
        holidays.pop();
        testAux.pop();
    }
    holidays.holidayPeriods.StartDay = [];
    holidays.holidayPeriods.StopDay = [];
    holidays.holidayPeriods.StartTime = [];
    holidays.holidayPeriods.StopTime = [];
    for (var a = 0; a < holidaysArray.length; a++) {
        holidays.holidayPeriods.StartDay.push(holidaysArray[a].startDay);
        holidays.holidayPeriods.StopDay.push(holidaysArray[a].stopDay);
        holidays.holidayPeriods.StartTime.push(holidaysArray[a].startTime);
        holidays.holidayPeriods.StopTime.push(holidaysArray[a].stopTime);
    }
    for (var del = holidaysArray.length; del < 24; del++) {
        holidays.holidayPeriods.StartDay.push("1.01");
        holidays.holidayPeriods.StopDay.push("1.01");
        holidays.holidayPeriods.StartTime.push(0);
        holidays.holidayPeriods.StopTime.push(0);
    }
    testAux = holidays.holidayPeriods;
}

var onChanged = function (attributeName, value) { //If any of the symbol element attributes listed below gets a change, a function can be called for each case.
    switch (attributeName) {
        case "value":
            //onValueChanged(value);											   //If the symbol elements' value is changed, we need to call a function to update the style on our circle.
            break;
        case "title":
            //parseTitle();
            break;
        case "minValue":
            //onMinValueChanged(value);
            break;
        case "maxValue":
            //onMaxValueChanged(value);
            break;
        case "visible":
            //onVisibleChanged(value);
            break;
    }
}

